import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

// test comment 
// Component imports
import Header from './components/Header';
import Footer from './components/Footer';

// Page imports 
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import SingleProject from './pages/SingleProject';


function AppRouter() {
  return (
    <Router>
      <div className="wrapper">
        <Header />
        <main>
          <Switch>
            <Route path="/" exact><Home /></Route>
            <Route path="/about"><About /></Route>
            <Route path="/projects"><Projects /></Route>
            <Route path="/contact"><Contact /></Route>
            <Route path="/project/:projectID"><SingleProject /></Route>
          </Switch>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default AppRouter;